import { Middleware } from '@nuxt/types'

const blockingRequestHistory: Middleware = async ({ $accessor, app, error }) => {
  if (!$accessor.app.config) {
    await $accessor.app.loadConfig()
  }
  if ($accessor.app.Resources === null) {
    await $accessor.app.loadPermissions()
  }
  if (!$accessor.app.userPermissions.blocking_request_history?.includes('view')) {
    error({ statusCode: 403, message: app.i18n.t('blocking_request_history.forbidden').toString() })
  }
}

export default blockingRequestHistory
